import { connect } from 'react-redux';

import { getCoworkingAddress } from 'shared/store/coworking/selectors/dump/getCoworkingAddress';
import { getCoworkingUnderground } from 'shared/store/coworking/selectors/dump/getCoworkingUnderground';
import { getSubdomain } from 'shared/store/subdomain';
import { IApplicationState } from 'shared/types/redux';

import { GeoBlock as GeoBlockComponent } from './GeoBlock';

export const mapState = (state: IApplicationState) => ({
  addressText: getCoworkingAddress(state),
  underground: getCoworkingUnderground(state),
  subdomain: getSubdomain(state),
});

export const GeoBlock = connect(mapState)(GeoBlockComponent);
